<div class="not-found">
  <section class="not-found-content-wrapper">
    <img
      src="assets/images/broken_paper.svg"
      width="111"
      height="100"
      alt="broken paper"
      class="not-found__illustration"
    />
    <h1 class="not-found__title">Oups, cette page n'existe pas</h1>
    <p class="not-found__description">Vous pouvez retourner à l'accueil</p>
    <a routerLink="" button> Retourner à l'accueil </a>
  </section>
</div>
